import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { submitAgencyEmailGuidelines } from '~/api/data/email-templates/mutations';
import { loadAgencyEmailGuidelines } from '~/api/data/email-templates/queries';
import { Action, Resource } from '~/api/graphql';
import { FEATURE_FLAGS } from '~/components/feature-flags';
import { FlagGuard } from '~/components/flag-guard';
import { ProtectedRoute } from '~/components/permissions';
import type { SettingsRouteHandle } from '~/pages/settings';
import { SettingsEmailLoadError, SettingsEmailPage } from '~/pages/settings/email';

/** The page titles itself, so that its description can link to the templates in Library. */
const OWN_PAGE_TITLE: SettingsRouteHandle = { ownPageTitle: true };

export const emailRoute: RouteObject = {
  element: <FlagGuard flag={FEATURE_FLAGS.EMAIL_TEMPLATES} to="/app/settings/profile" />,
  children: [
    {
      path: 'email',
      handle: OWN_PAGE_TITLE,
      loader: merge({ emailGuidelines: loadAgencyEmailGuidelines }),
      action: byMethod({ PUT: submitAgencyEmailGuidelines }),
      element: (
        <ProtectedRoute
          permissions={[{ resource: Resource.Agency, action: Action.Update }]}
          redirectTo="/app/settings/profile"
        >
          <SettingsEmailPage />
        </ProtectedRoute>
      ),
      errorElement: <SettingsEmailLoadError />
    }
  ]
};
